import { useQuery } from '@tanstack/react-query'
import { fetchLumpsumIdealPlanRecommendation } from '../api/repository'
import { PlanCategoryBucketKey } from '../../api/types'
import { LUMPSUM_PLANS_API_RETRY_COUNT, isLumpsumQueryFetchFailed, isLumpsumQueryLoading } from '../../api/queryOptions'
import type { LumpsumIdealPlanRecommendationApiResponse } from '../api/idealRecommendation.types'
import { IdealPlanRecommendationSheet } from './IdealPlanRecommendationSheet'

const IDEAL_PLAN_RECOMMENDATION_QUERY_KEY = 'lumpsum-plans-v4-ideal-recommendation'

export function IdealPlanRecommendationContainer(input: {
  onDismiss: () => void
  isin: string
  bucketType?: PlanCategoryBucketKey
}) {
  const { onDismiss, isin, bucketType } = input
  const { planDetails, isLoading, isFetchFailed, onRetry } = useIdealPlanRecommendation(isin, true)

  return (
    <IdealPlanRecommendationSheet
      onDismiss={onDismiss}
      isin={isin}
      planDetails={planDetails}
      isLoading={isLoading}
      isFetchFailed={isFetchFailed}
      onRetry={onRetry}
      bucketType={bucketType}
    />
  )
}

function useIdealPlanRecommendation(isin: string, enabled: boolean): {
  planDetails: LumpsumIdealPlanRecommendationApiResponse | null
  isLoading: boolean
  isFetchFailed: boolean
  onRetry: () => void
} {
  const query = useQuery({
    queryKey: [IDEAL_PLAN_RECOMMENDATION_QUERY_KEY, isin],
    queryFn: () => fetchLumpsumIdealPlanRecommendation(isin),
    enabled: enabled && isin.length > 0,
    retry: LUMPSUM_PLANS_API_RETRY_COUNT
  })

  return {
    planDetails: query.data ?? null,
    isLoading: isLumpsumQueryLoading(query),
    isFetchFailed: isLumpsumQueryFetchFailed(query),
    onRetry: () => {
      void query.refetch()
    }
  }
}
